export class BlipRoute {
  static readonly Messaging = "https://msging.net/commands";
}
